export default {"src":"/_next/static/media/licensed.abb449e1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};